import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Leaflet from 'leaflet';

import "./Map.scss";
import "leaflet/dist/leaflet.css";

/**
 * Component that shows a map
 */
class Map extends Component {
   constructor(props) {
      super(props);

      this.state = {map: undefined}
   }

   componentDidMount() {
                           // create map control
      var map = new Leaflet.Map(this.mapContainer, this.getMapOptions());
                           // controls should be only on desktop, at the bottom right
      if (Leaflet.Browser.mobile)
         map.removeControl(map.zoomControl);
      else
         map.zoomControl.setPosition('bottomright');

      if (this.props.onLongPress) {
         map.on('contextmenu', (mouseEvent) => this.props.onLongPress(mouseEvent.latlng));
      }

      // On force la carte a recalculer sa taille après le chargement: ref obs607783
      map.whenReady(() => {
         this.invalidateSize();
      })

      map.createPane('geoJsonPane');
      map.getPane('geoJsonPane').style.zIndex = 450;

      this.setState(
         { map: map },
                          // Force Leaflet to recalculate the canvas size.
                          // This has to be done in dev mode since the CSS is loaded after the leaflet JS
                          // In production mode, css is loaded in link tags in the head, and therefore this is not a problem
         () => {
            this.invalidateSize();
         }
      );
   }

   componentWillUnmount() {
      this.state.map.remove();
   }

   /**
    * Builds the map options from props
    * @returns {object} mapOptions object that can be used with leaflet
    */
   getMapOptions() {
      let mapOptions = {
         preferCanvas: true, /*Permet d'afficher une grande quantité de GeoJSON efficacement*/
         layers: [
            Leaflet.tileLayer(this.props.tileServerURL, {
               accessToken: this.props.accessToken,
               attribution: this.props.attribution,
               zoomOffset: this.props.zoomOffset,
               tileSize: this.props.tileSize
            })
         ],
         center: this.props.center,
         zoom: this.props.zoom,
         minZoom: this.props.minZoom,
         maxZoom: this.props.maxZoom
      };

      return (mapOptions);
   }

   /**
    * Invalidate map size. Must be called when the number of tiles shown has to be recalculated.
    */
   invalidateSize() {
      setTimeout(() => this.state.map.invalidateSize(), 0);
   }

   /**
    * renders the map component
    */
   render () {
      return (
         <div className={this.props.className}>
            <div className="map-container" ref={el => this.mapContainer = el}>
               {
                  this.state.map &&
                  React.Children.map(this.props.children, (child, index) => {
                     if (!child)
                        return (null);
                     return (React.cloneElement(child, {
                        map: this.state.map,
                        layerOrder: index+1
                     }));
                  })
               }
            </div>
         </div>
      );
   }
}

Map.defaultProps = {
   zoom: 10
}

Map.propTypes = {
   /**
    * defines the access token for the map service, when null,
    * a tileServerURL must be provided
    */
   accessToken: PropTypes.string,
   /**
    * defines the attribution text to display on the map,
    * might be required legally depending on the tile server used.
    */
   attribution: PropTypes.string,
   /**
    * defines the center of the map, default is 0,0
    */
   center: PropTypes.arrayOf(PropTypes.any),
   /**
    * defines the map container css classnames
    */
   className: PropTypes.string,
   /**
    * function to call when doing a long press on the map. There is
    * no default action for the long press
    */
   onLongPress: PropTypes.func,
   /**
    * defines the minimum zoom, default is 0
    */
   minZoom: PropTypes.number,
   /**
    * defines the maximum zoom, default is 21
    */
   maxZoom: PropTypes.number,
   /**
    * defines the maximum bounds to restricts the map to the given geographical bounds.
    */
   maxBounds: PropTypes.array,
   /**
    * defines the url for the tile server,
    * ex: "http://myurl/tileserver/{z}/{x}/{y}.png"
    */
   tileServerURL: PropTypes.string.isRequired,
   /**
    * defines the default zoom level, default value is 10
    */
   zoom: PropTypes.number
}

export default Map;
